import React, { useState } from "react";
import Swal from "sweetalert2";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import FilterAltIcon from "@mui/icons-material/FilterAlt";

import { EjercicioSelect } from "../../helpers/EjercicioSelected";
import PeriodoSelected from "../../helpers/PeriodoSelected";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { CarteraSelect, LineaSelect } from "./CarteraSelect";

import TelefonoSelect from "./TelefonoSelect";


export const FiltroPlantillasKarbot = ({ onExecute, msgTitulo }) => {
  const [openModal, setOpenModal] = useState(false);
  const [state, setState] = useState({

    linea: "R",
    cartera: "",
    telefono: "",

  });
  const onOpenModal = () => {
    const container = document.getElementById("mdlFiltros-modal");
    if (!container) return;
    if (openModal) {
      container.style.display = "flex";
      setOpenModal(false);
    } else {
      container.style.display = "none";
      setOpenModal(true);
    }
  };

  const onCargar = () => {
    if (
      state.linea === undefined ||
      state.linea === null ||
      state.linea === ""
    ) {
      Swal.fire(
        "PLANTILLAS KARBOT",
        "Favor de seleccionar una cartera de clientes",
        "warning"
      );
      return;
    }
    if (
      state.cartera === undefined ||
      state.cartera === null ||
      state.cartera === ""
    ) {
      Swal.fire(
        "PLANTILLAS KARBOT",
        "Favor de seleccionar una cartera de clientes",
        "warning"
      );
      return;
    }
    onExecute(state.linea, state.cartera, state.telefono).then(() => {
      onOpenModal();
    });
  };
  return (
    <div className="plantilla-screen-filtro">
      <div
        className="plantilla-screen-filtro-button-modal"
        onClick={onOpenModal}
      >
        <FilterAltIcon /> Filtrar
      </div>
      <div className="plantilla-screen-filtro-container" id="mdlFiltros-modal">
        <PlantillaScreen
          titulo={`Filtro`}
          className_main={1}
          className={"plantilla-screen-filtro-container-modal"}
        >
          <div className="plantilla-screen-filtro-container-modal-container">
            <LineaSelect
              value={state.linea}
              onChange={(linea) => setState({ ...state, linea })}
              className="plantilla-screen-filtro-container-modal-container-linea"
            />
            <CarteraSelect
              value={state.cartera}
              onChange={(cartera) => setState({ ...state, cartera })}
              className="plantilla-screen-filtro-container-modal-container-linea"
            />
            <TelefonoSelect
              value={state.telefono}
              onChange={(telefono) => setState({ ...state, telefono })}
              className="plantilla-screen-filtro-container-modal-container-linea"
            />
            <div className="plantilla-screen-filtro-container-modal-modal-acciones">
              <div
                className="plantilla-screen-filtro-container-modal-modal-acciones-cancelar"
                onClick={onOpenModal}
              >
                Cancelar
              </div>
              <div
                className="plantilla-screen-filtro-container-modal-modal-acciones-guardar"
                onClick={onCargar}
              >
                Cargar
              </div>
            </div>
          </div>
        </PlantillaScreen>
      </div>
    </div>
  );
};
